export default __webpack_public_path__ + "static/media/work-three.20fef82d.PNG";